import { Text } from 'components/Text'
import React, { useEffect, useState } from 'react'
import {
  PaymentSectionContainer,
  PaymentSectionHeaderContainer,
  PaymentStatusContainer,
} from './PaymentSection.styled'
import SVG from 'react-inlinesvg'
import CancelIcon from 'assets/icons/cancel.svg'
import CheckIcon from 'assets/icons/check.svg'
import { PaymentSectionProps } from './PaymentSection.props'
import { InvoicesPaymentAppointments } from 'services/appointment/appointment.types'
import moment from 'moment'

const PaymentSection = ({invoice}: PaymentSectionProps) => {

  const [paymentList, setPaymentList] = useState<InvoicesPaymentAppointments[]>([]);

  useEffect(()=>{
    const {payments} = invoice;
    setPaymentList(payments);
  }, [invoice]);

  const getPriceInPennies = (price: any) => price !== 0 ? price / 100 : price;

  return (
    <PaymentSectionHeaderContainer>
      {paymentList.map(payment => (
        <PaymentSectionContainer key={invoice.id}>
          <Text
            text={`Invoiced ${invoice.user.title} $${getPriceInPennies(invoice.amount)} on ${moment(invoice.created_at).format('MM/DD/yyyy')}`}
            weight="400"
            style={{ width: '100%' }}
          />
          <PaymentStatusContainer>
            <Text text={payment.payment_status} weight="400" style={{ textTransform: 'capitalize' }} />
            {payment.payment_status.toLowerCase() === 'unpaid' && (
              <SVG
                src={CancelIcon}
                style={{ marginLeft: 15 }}
              />
            )}
            {payment.payment_status.toLowerCase() === 'paid' && (
              <SVG
                src={CheckIcon}
                style={{ marginLeft: 15 }}
              />
            )}
          </PaymentStatusContainer>
        </PaymentSectionContainer>
      ))}
    </PaymentSectionHeaderContainer>
  )
}

export default PaymentSection
